import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const EventTeamAccessPage = lazy(() => import('./event-team-access-page'));

const EventTeamAccessRoute = () => {
  return (
    <LazyRoute>
      <EventTeamAccessPage />
    </LazyRoute>
  );
};

export { EventTeamAccessRoute };
